import type { Editor } from "grapesjs";
import { BlockItem } from "../../../../templates/types/block-item.types";

type RegisterBlocksOptions = {
    templateName?: string;
    description?: string;
};

function getSourceLabel(it: BlockItem, opts?: RegisterBlocksOptions) {
    if (it.source === "basic") return "Basic";
    return `Template: ${opts?.templateName ?? it.templateId ?? "Custom"}`;
}

function getCategory(it: BlockItem, opts?: RegisterBlocksOptions) {
    return `${getSourceLabel(it, opts)} / ${it.group}`;
}

export function registerBlocks(editor: Editor, items: readonly BlockItem[], opts?: RegisterBlocksOptions) {
    const bm = editor.BlockManager;

    items.forEach((it) => {
        if (bm.get(it.id)) return;

        bm.add(it.id, {
            label: it.label,
            category: getCategory(it, opts),
            content: typeof it.content === "function" ? it.content() : it.content,
            attributes: {
                title: opts?.description ?? it.description ?? '', // native tooltip
                'data-description': opts?.description ?? it.description ?? '',
            },
        });

    });
}
